import type { DropMenu } from '../components/Dropdown';
import { LangEnum } from '../enums/appEnum';
import type { LocaleSetting } from '/#/config';

export const localeSetting: LocaleSetting = {
  showPicker: false,
  // Locale
  locale: LangEnum.EN_US,
  // Default locale
  fallback: LangEnum.EN_US,
  // available Locales
  availableLocales: [LangEnum.ZH_CN, LangEnum.EN_US, LangEnum.KO_KR, LangEnum.AR_AE],
};

// locale list
export const localeList: DropMenu[] = [
  {
    text: '简体中文',
    event: LangEnum.ZH_CN,
  },
  {
    text: 'English',
    event: LangEnum.EN_US,
  },
  {
    text: '한국어',
    event: LangEnum.KO_KR,
  },
  {
    text: 'بالعربية',
    event: LangEnum.AR_AE,
  },
];
